import React from "react";
import Booking from "../../components/Booking";

const BookingPage = () => {
  return <Booking />;
};

export default BookingPage;
